<template>
    <div class="skeleton" :data-total="rows.length">
        <div class="skeleton-item" v-for="(row, index) in rows" :key="index" :data-total="rows.length">
            <slot>
                <div class="col-xs-8 col-sm-6">
                    <div class="line small m-b-10"></div>
                    <div class="line big"></div>
                </div>
                <div class="hidden-xs col-sm-4">
                    <div class="line big m-b-10"></div>
                    <div class="line small"></div>
                </div>
                <div class="col-xs-4 col-sm-2">
                    <div class="line small m-b-10"></div>
                    <div class="line big"></div>
                </div>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        rows: {
            type: Number,
            required: false,
            default: 5,
        }
    }
}
</script>

<style lang="scss" scoped>
.skeleton .skeleton-item {
    height: 80px;
    width: 100%;
    background-color: var(--n-color-nav-surface);
    margin-bottom: 30px;
    padding: 20px 25px;
    box-sizing: border-box;
    opacity: 0;
    
    .circle {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #EBEFF2;
    }
    
    .line {
        height: 10px;
        background-color: #EBEFF2;
        margin: 5px 0px;
    }
    
    .small {
        width: 70px;
    }
    
    .big {
        width: 110px;
    }
    
    &:nth-child(1) {
        animation: fade-in .8s ease-out forwards;
    }
    
    &:nth-child(2) {
        animation: fade-in .8s ease-out forwards;
        animation-delay: .2s;
    }
    
    &:nth-child(3) {
        animation: fade-in .8s ease-out forwards;
        animation-delay: .4s;
    }
    
    &:nth-child(4) {
        animation: fade-in .8s ease-out forwards;
        animation-delay: .6s;
    }
    
    &:nth-child(5) {
        animation: fade-in .8s ease-out forwards;
        animation-delay: .8s;
    }
}
</style>